import map from 'lodash/map'

import ClientStore from './Client.store'
import ComplianceStore from './compliance.store'
import ContractStore from './Contract.store'
import DashboardStore from './Dashboard.store'
import DeliverableStore from './Deliverable.store'
import SidebarStore from './Sidebar.store'
import ContactProjectsStore from './ContactProjects.store'
import NotificationStore from './Notification.store'
import EPLStore from './EPL.store'
import UploadStore from './Upload.store'
import SearchStore from './Search.store.js'
import MyProjectsStore from './MyProjects.store'
import ClientProjectsStore from './ClientProjects.store'
import EmployeeStore from './Employee.store'
import ExpertBulkCreateStore from './ExpertBulkCreate.store'
import ExpertSearchStore from './ExpertSearch.store'
import ExpertStore from './Expert.store'
import GrowlStore from './Growl.store'
import InvoiceStore from './Invoice.store'
import RevenuesStore from './Reports.store/Revenues.store'
import ClientSearchStore from './ClientSearch.store/ClientSearch.store'
import ParentAccountStore from './ClientSearch.store/ParentAccount.store'
import ProjectsListingStore from './ClientSearch.store/ProjectsListing.store'
import AccountsAndOfficesStore from './AccountsAndOffices.store'
import ProjectsPipelineStore from './Reports.store/ProjectsPipeline.store'
import InvoicingStore from './ClientSearch.store/Invoicing.store'
import ContractsStore from './Contracts.store'
import LogStore from './Log.store'
import AccountStore from './ClientSearch.store/Account.store'
import OfficeStore from './ClientSearch.store/Office.store'
import CreatedInvoicesStore from './Reports.store/CreatedInvoices.store'
import DraftedInvoicesStore from './Reports.store/DraftedInvoices.store'
import PerformanceStore from './Reports.store/Performance.store'
import ModalStore from './Modal.store'
import PaymentDetailsStore from './PaymentDetails.store'
import RuleStore from './Rule.store'
import staticData from './staticData.store'
import UserStore from './user.store'
import GeneralFeesStore from './GeneralFees.store'
import EmployeeSearchStore from './EmployeeSearch.store'
import FinancialRevenueStore from './Reports.store/FinancialRevenue.store'
import ContractAssignStore from './contractAssign.store'
import CurrencyRatesStore from './Reports.store/CurrencyRates.store'
import AtheneumOfficeStore from './AtheneumOffice.store'
import EmailTemplatesStore from './EmailTemplates.store'
import PaymentsStore from './Reports.store/Payments.store'
import ParentMetricStore from './ClientSearch.store/ParentMetric.store'
import QueueProcessorStore from './QueueProcessor.store'
import socketIOClient from 'socket.io-client'
import ActiveProjectStore from './ActiveProject.store'
import CorrespondenceStore from './Correspondence.store'
import ComplianceBreachStore from './ComplianceBreach.store'
import ZoomRecordingStore from './ZoomRecording.store'

export const socket = socketIOClient.connect({
  transports: ['websocket']
})

const atheneumOfficeStore = new AtheneumOfficeStore()
const growlStore = new GrowlStore()
const notificationStore = new NotificationStore(growlStore)
const userStore = new UserStore(socket, staticData, notificationStore)
const paymentDetailsStore = new PaymentDetailsStore(growlStore)
const modalStore = new ModalStore()
const deliverableStore = new DeliverableStore()
const sidebarStore = new SidebarStore()
const clientStore = new ClientStore()
const contactProjectsStore = new ContactProjectsStore(staticData)
const eplStore = new EPLStore(staticData, growlStore)
const searchStore = new SearchStore()
const uploadStore = new UploadStore(growlStore)
const myProjectsStore = new MyProjectsStore()
const clientProjectsStore = new ClientProjectsStore(growlStore)
const employeeStore = new EmployeeStore()
const expertBulkCreateStore = new ExpertBulkCreateStore(staticData, modalStore, growlStore, userStore)
const expertSearchStore = new ExpertSearchStore(socket, expertBulkCreateStore)
const expertStore = new ExpertStore(staticData, growlStore, expertSearchStore)
const invoiceStore = new InvoiceStore(growlStore, staticData)
const ruleStore = new RuleStore(userStore, staticData)
const contractStore = new ContractStore(staticData, growlStore)
const dashboardStore = new DashboardStore(staticData, userStore)
const revenuesStore = new RevenuesStore(staticData, atheneumOfficeStore)
const logStore = new LogStore()
const clientSearchStore = new ClientSearchStore()
const parentAccountStore = new ParentAccountStore(staticData, growlStore)
const projectsListingStore = new ProjectsListingStore()
const accountsAndOfficesStore = new AccountsAndOfficesStore(
  staticData,
  atheneumOfficeStore
)
const invoicingStore = new InvoicingStore(staticData, growlStore)
const contractsStore = new ContractsStore(staticData)
const accountStore = new AccountStore(growlStore)
const officeStore = new OfficeStore(growlStore)
const projectsPipelineStore = new ProjectsPipelineStore(atheneumOfficeStore)
const createdInvoicesStore = new CreatedInvoicesStore(staticData)
const draftedInvoicesStore = new DraftedInvoicesStore(staticData)
const paymentStore = new PaymentsStore(staticData)
const performanceStore = new PerformanceStore(staticData)
const generalFeesStore = new GeneralFeesStore()
const employeeSearchStore = new EmployeeSearchStore(staticData)
const financialRevenueStore = new FinancialRevenueStore(staticData)
const contractAssignStore = new ContractAssignStore()
const currencyRatesStore = new CurrencyRatesStore(staticData)
const parentMetricStore = new ParentMetricStore()
const emailTemplatesStore = new EmailTemplatesStore(staticData)
const complianceStore = new ComplianceStore(growlStore)
const queueProcessorStore = new QueueProcessorStore(userStore, socket)
const activeProjectStore = new ActiveProjectStore(growlStore)
const correspondenceStore = new CorrespondenceStore(staticData)
const complianceBreachStore = new ComplianceBreachStore()
const zoomRecordingStore = new ZoomRecordingStore()

const stores = {
  userStore,
  paymentDetailsStore,
  staticData,
  complianceStore,
  modalStore,
  growlStore,
  deliverableStore,
  sidebarStore,
  clientStore,
  contactProjectsStore,
  notificationStore,
  eplStore,
  searchStore,
  uploadStore,
  myProjectsStore,
  clientProjectsStore,
  employeeStore,
  expertSearchStore,
  expertStore,
  expertBulkCreateStore,
  invoiceStore,
  contractStore,
  dashboardStore,
  revenuesStore,
  logStore,
  clientSearchStore,
  parentAccountStore,
  projectsListingStore,
  accountsAndOfficesStore,
  invoicingStore,
  contractsStore,
  accountStore,
  officeStore,
  projectsPipelineStore,
  createdInvoicesStore,
  draftedInvoicesStore,
  paymentStore,
  performanceStore,
  ruleStore,
  generalFeesStore,
  employeeSearchStore,
  financialRevenueStore,
  contractAssignStore,
  currencyRatesStore,
  atheneumOfficeStore,
  emailTemplatesStore,
  parentMetricStore,
  queueProcessorStore,
  activeProjectStore,
  correspondenceStore,
  complianceBreachStore,
  zoomRecordingStore
}
window.stores = stores

const initStores = (history) => {
  return Promise.all(
    map(stores, async store => {
      if (typeof store.init === 'function') {
        await store.init()
      }
      if (typeof store.addHistory === 'function') {
        await store.addHistory(history)
      }
      return Promise.resolve()
    })
  )
}

export { stores, initStores }
